import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createShipping,
  deleteShipping,
  getShipping,
} from "../../../services/shipping";
import { useAuth } from "../../../utils/AuthContext";
import toast from "react-hot-toast";

function useShipping() {
  const { isLoggedIn, user } = useAuth();
  const queryClient = useQueryClient();
  const shippingData = useQuery({
    queryFn: getShipping,
    queryKey: ["shipping"],
    enabled: !!isLoggedIn && +user?.role === 1,
  });

  const createShippingMutation = useMutation({
    mutationFn: (shippingData) => {
      // console.log("shipping data from use shipping: ", shippingData);
      return createShipping(shippingData);
    },
    onSuccess() {
      queryClient.invalidateQueries(["shipping"]);
      toast.success("shipping has been created successfully!");
    },
    onError() {
      toast.error("error creating shipping!");
    },
  });

  //   DELETE SHIPPING OPTION
  const deleteShippingMutation = useMutation({
    mutationFn: (id) => deleteShipping(id),
    onSuccess: () => {
      queryClient.invalidateQueries(["shipping"]);
      toast.success("shipping option has been deleted successfully!");
    },
    onError: () => {
      toast.error("error deleting shipping option!");
    },
  });

  return {
    // SHIPPING DATA
    shippingData: shippingData.data?.data,
    isGettingShippingData: shippingData.isLoading,
    errorGettingShippinData: shippingData.error,

    // CREATE SHIPING
    createShippingFn: createShippingMutation.mutate,
    isCreatingShipping: createShippingMutation.isLoading,

    // DELETE SHIPPING
    deleteShippingFn: deleteShippingMutation.mutate,
    isDeletingShipping: deleteShippingMutation.isLoading,
    // GET SHIPPING BY ID

    // UPDATE SHIPPING
  };
}

export default useShipping;
